import { Check } from 'lucide-react';

export default function ConverterSteps({ steps, currentStep }) {
  return (
    <ol className="flex flex-wrap gap-2 sm:gap-0 sm:justify-between mb-6" aria-label="Conversion steps">
      {steps.map((step, i) => {
        const done = i < currentStep;
        const active = i === currentStep;
        return (
          <li
            key={step.id}
            className={`flex items-center gap-2 text-xs sm:text-sm rounded-full px-3 py-1.5 border transition-colors ${
              active
                ? 'border-emerald-500 bg-emerald-500/10 text-emerald-300'
                : done
                  ? 'border-slate-600 bg-slate-800/80 text-slate-400'
                  : 'border-slate-700 text-slate-500'
            }`}
          >
            <span
              className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold ${
                active
                  ? 'bg-emerald-500 text-white'
                  : done
                    ? 'bg-slate-600 text-slate-200'
                    : 'bg-slate-800 text-slate-500'
              }`}
            >
              {done ? <Check className="w-3 h-3" /> : i + 1}
            </span>
            <span className="hidden sm:inline">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
